module.exports = __webpack_public_path__ + "img/max-file-check--pdf.477d45bc.svg";